import { gql } from "@apollo/client";

export const getPayoutStatsSummary = gql`
    query payoutStatsSummary($input: PayoutStatsInput!) {
        payoutStats(input: $input) {
            summary {
                totalEarningsMilliUsd
                totalPayoutCount
                totalSubscriptionCount
                totalSubscriberUniqueUsers
                firstPayoutAt
                lastPayoutAt
                lensPlusScore
                lensPlusSignups {
                    total
                    paid
                    settled
                    estimated
                }
                countryBreakdown {
                    countryCode
                    amountMilliUsd
                    payoutCount
                    subscriptionCount
                    lensPlusSignups {
                        total
                        paid
                        settled
                        estimated
                    }
                }
            }
        }
    }
`;
